import React from 'react';
import CaptureStripeHeader from './CaptureStripeHeader';

interface CardColorModalProps {
  open: boolean;
  onSelect: (color: 'yellow' | 'red') => void;
  onClose: () => void;
}

const CardColorModal: React.FC<CardColorModalProps> = ({ open, onSelect, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-5" onClick={onClose}>
      <div className="w-full max-w-md bg-white shadow-xl overflow-hidden" onClick={(event) => event.stopPropagation()}>
        <CaptureStripeHeader tone="green" title="YELLOW / RED CARD" />
        <div className="px-6 pt-8 pb-10">
          <p className="text-center text-xl font-semibold text-sd-ink mb-8">Was it a yellow or red card?</p>
          <div className="flex gap-4">
            <button
              type="button"
              className="flex-1 rounded-md bg-[#f6e27a] text-sd-ink font-bold py-3 text-lg shadow"
              onClick={() => onSelect('yellow')}
            >
              Yellow
            </button>
            <button
              type="button"
              className="flex-1 rounded-md bg-[#e86b56] text-white font-bold py-3 text-lg shadow"
              onClick={() => onSelect('red')}
            >
              Red
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardColorModal;
